import React, { memo, useState, lazy, Suspense, useMemo } from "react";
import ExpandMore from "@material-ui/icons/ExpandMore";
import ChevronRight from "@material-ui/icons/ChevronRight";
import Action from "./action";
import FilterPopup from "./FilterPopup";
import { useSelector } from "react-redux";
import { selectUserRole } from "redux/permission/selector";
import { useFetchDetail } from "hooks/useFetchDetail";
import { selectImageId } from "redux/image/selectors";
import { USER_ROLES } from "helpers/constants";
import CircularProgress from "@material-ui/core/CircularProgress";
import styles from "./style.module.scss";

const DataRegistries = lazy(() => import("./data-registries"));

const Attributes = () => {
  const [isCollapsed, setIsCollapsed] = useState(true);
  const [visibility, setVisibility] = useState(undefined);
  const role = useSelector(selectUserRole);
  const imageId = useSelector(selectImageId);

  const params = useMemo(() => ({ visibility }), [visibility]);

  const { data, loading, refetch } = useFetchDetail({
    url: `/data-registry/v2/source`,
    id: imageId,
    params,
  });

  const handleApplyFilter = (newVisibility) => {
    setVisibility(newVisibility);
  };
  return (
    <div className={styles.container}>
      <div className={styles.headerAttributes} role="button" tabIndex="0">
        <div className={styles.headerLeft}>
          <button type="button" onClick={() => setIsCollapsed((prev) => !prev)}>
            {isCollapsed ? <ExpandMore /> : <ChevronRight />}
          </button>
          <span>Attributes</span>
        </div>
        <div className={styles.headerRight}>
          {role === USER_ROLES.ADMIN && data?.sourceAttribute?.length > 0 && (
            <>
              <FilterPopup visibility={visibility} onApply={handleApplyFilter} />
              <Action
                attributes={data?.sourceAttribute ?? []}
                refetch={refetch}
                sourceId={imageId}
              />
            </>
          )}
        </div>
      </div>
      {isCollapsed && (
        <div>
          {loading ? (
            <div>
              <CircularProgress size={16} />
            </div>
          ) : (
            <div>
              {isCollapsed && (
                <Suspense fallback={<></>}>
                  <DataRegistries
                    sourceId={imageId}
                    attributes={data?.sourceAttribute ?? []}
                    refetch={refetch}
                  />
                </Suspense>
              )}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default memo(Attributes);
